<template>
  <div class="courseinfo-wrapper">
    <iframe scrolling="no" :src="url" frameborder="0"></iframe>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        url: this.dataList.replace('https:', '')
      }
    },
    props: ['dataList'],
    mounted () {
      window.onmessage = function (e) {
        $('iframe').height(e.data.height)
      }
    },
    methods: {}
  }
</script>

<style lang="less" scoped>
  .courseinfo-wrapper {
    background: #ffffff;
    iframe {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/index/courseinfo.vue